export default Object.freeze({
  unset: 'unset',
  document: 'document',
  agreement: 'agreement',
  form: 'form',
})
